import { TZDate, TZDateMini } from '@date-fns/tz';
import clsx from 'clsx';
import { startOfWeek, addDays } from 'date-fns';
import { type ReactNode } from 'react';
import { type DayOfWeek } from 'weekstart';

import { formatDate } from '@dynatrace-sdk/units';

import { Text } from '../../../typography/text/Text.js';
import { eachDayOfInterval } from '../../forms-core/time/helpers.js';
import * as styles from '../Calendar.sty.js';

/** @internal */
export function Weekdays({
  weekStartsOn,
  configuredTimezone,
}: Readonly<{
  weekStartsOn: DayOfWeek;
  configuredTimezone: string;
}>): ReactNode {
  // Generate an array of dates representing each day of the week
  const today = TZDateMini.tz(configuredTimezone);
  const intervalStart = startOfWeek(today, {
    weekStartsOn,
  });

  // Generate an array of dates representing each day of the week
  const days = eachDayOfInterval({
    start: intervalStart,
    end: addDays(intervalStart, 6) as TZDate,
  });

  return (
    <thead>
      <tr className={clsx([styles.row, styles.dayRow, styles.weekdays])}>
        {days.map((weekday, index) => (
          <th
            key={`${weekday}-${index}`}
            className="weekday"
            abbr={formatDate(weekday, {
              weekday: 'long',
              timeZone: configuredTimezone,
            })}
            scope="col"
          >
            <Text textStyle="small" as="p">
              {formatDate(weekday, {
                weekday: 'short',
                timeZone: configuredTimezone,
              })}
            </Text>
          </th>
        ))}
      </tr>
    </thead>
  );
}
